import React from "react";
import { View } from "react-native";
import { useBiblo } from "../hooks/Biblo.hook";
import { getViewStyles } from "../helpers/getStyles.helper";
export const Separator = props => {
  const {
    defaultStyles
  } = useBiblo();
  return /*#__PURE__*/React.createElement(View, {
    style: getViewStyles(props.style, {
      marginHorizontal: defaultStyles.spacing,
      height: 1,
      backgroundColor: defaultStyles.separatorColor
    }, props.disableDefaultStyles)
  });
};
//# sourceMappingURL=Separator.component.js.map